"use strict";

export { default as D5FormLayoutTabs } from './D5FormLayoutTabs';
export { default as D5FormLayoutPanel } from './D5FormLayoutPanel';